import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { FNOLPACollisionDetailsPage } from 'gwce-capability-fnol-pa-react-ext';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';


function FNOLRTCollisionDetailsPage(props) {
    return <FNOLPACollisionDetailsPage {...props} />;

}

FNOLRTCollisionDetailsPage.propTypes = wizardProps;
FNOLRTCollisionDetailsPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};
export default withRouter(FNOLRTCollisionDetailsPage);
